import squat from '@/assets/exercises/squat.jpg';
import sissySquat from '@/assets/exercises/sissy-squat.jpg';
import wristRotation from '@/assets/exercises/wrist-rotation.jpg';
import bulgarian from '@/assets/exercises/bulgarian.jpg';
import legPress from '@/assets/exercises/leg-press.jpg';
import lunges from '@/assets/exercises/lunges.jpg';
import adductor from '@/assets/exercises/adductor.jpg';
import benchPress from '@/assets/exercises/press-horizontal-mancuernas.jpg';
import benchPressIncline from '@/assets/exercises/bench-press-incline.jpg';
import pressMachine from '@/assets/exercises/press-machine.jpg';
import cableCrossover from '@/assets/exercises/cable-crossover.jpg';
import bicepCurl from '@/assets/exercises/bicep-curl.jpg';
import bicepCurlProno from '@/assets/exercises/bicep-curl-prono.jpg';
import bicepCurlCable from '@/assets/exercises/bicep-curl-cable.jpg';
import skullCrusher from '@/assets/exercises/skull-crusher.jpg';
import tricepExtension from '@/assets/exercises/tricep-extension.jpg';
import crunch from '@/assets/exercises/crunch.jpg';
import hipopresivo from '@/assets/exercises/hipopresivo.jpg';
import crunchSostenido from '@/assets/exercises/crunch-sostenido.jpg';
import crunchSide from '@/assets/exercises/crunch-side.jpg';
import calfRaise from '@/assets/exercises/calf-raise.jpg';
import wristCurl from '@/assets/exercises/wrist-curl.jpg';
import latPulldown from '@/assets/exercises/lat-pulldown.jpg';
import row from '@/assets/exercises/row.jpg';
import pullover from '@/assets/exercises/pullover.jpg';
import shoulderPress from '@/assets/exercises/shoulder-press.jpg';
import lateralRaise from '@/assets/exercises/lateral-raise.jpg';
import lateralRaiseIncline from '@/assets/exercises/lateral-raise-incline.jpg';
import frontalRaiseCable from '@/assets/exercises/frontal-raise-cable.jpg';
import abductor from '@/assets/exercises/abductor.jpg';
import cableKickback from '@/assets/exercises/cable-kickback.jpg';
import stepUp from '@/assets/exercises/step-up.jpg';
import gluteBridge from '@/assets/exercises/glute-bridge.jpg';
import gluteBridgeIso from '@/assets/exercises/glute-bridge-iso.jpg';
import rowDumbbell from '@/assets/exercises/row-dumbbell.jpg';
import deadlift from '@/assets/exercises/deadlift.jpg';
import legCurl from '@/assets/exercises/leg-curl.jpg';
import rearDelt from '@/assets/exercises/rear-delt.jpg';
import oblique from '@/assets/exercises/oblique.jpg';

const exerciseImageMap: Record<string, string> = {
  'Sentadilla en Smith': squat,
  'Sentadilla Sissy Lastrada': sissySquat,
  'Búlgara en Smith': bulgarian,
  'Prensa': legPress,
  'Desplantes caminados con mancuernas': lunges,
  'Aductor en máquina': adductor,
  'Máquina abductora': abductor,
  'Press Inclinado en Smith': benchPressIncline,
  'Press horizontal c/mancuernas': benchPress,
  'Press máquina a una mano': pressMachine,
  'Cruces en polea': cableCrossover,
  'Curl de bícep concentrado c/mancuerna': bicepCurl,
  'Curl de bíceps c/barra multifuncional': bicepCurlCable,
  'Curl de bíceps agarre prono c/barra': bicepCurlProno,
  'Rompe cráneos c/barra Z': skullCrusher,
  'Extensión de tríceps en polea agarre V': tricepExtension,
  'Crunch con encogimiento sostenidas': crunchSostenido,
  'Hipopresivo acostado': hipopresivo,
  'Crunch acostado de lado': crunchSide,
  'Costurera': oblique,
  'Elevación de talones en Smith': calfRaise,
  'Flexión de muñecas c/mancuernas': wristCurl,
  'Rotaciones c/mancuerna': wristRotation,
  'Jalón al pecho c/barra': latPulldown,
  'Remo sentado en máquina una mano': row,
  'Remo c/mancuerna a una mano': rowDumbbell,
  'Pull over agarre V': pullover,
  'Posterior en polea baja': rearDelt,
  'Press de hombro c/mancuernas sentado': shoulderPress,
  'Elevación lateral inclinado en banco': lateralRaiseIncline,
  'Elevación frontal grillete polea media': frontalRaiseCable,
  'Patada bailarina c/grillete': cableKickback,
  'Step up en Smith': stepUp,
  'Puentes en Smith pisando Step': gluteBridge,
  'Puente isométrico a una pierna': gluteBridgeIso,
  'Peso muerto a una pierna c/mancuerna': deadlift,
  'Femoral acostado máquina una pierna': legCurl,
};

export function getExerciseImage(name: string): string | undefined {
  return exerciseImageMap[name];
}
